import { Routes } from '@angular/router';

import { SignInPageComponent } from './features/auth/pages/sign-in-page.component';
import { ByCategoryPageComponent } from './features/numerons/pages/by-category-page.component';
import { ByTopicPageComponent } from './features/numerons/pages/by-topic-page.component';
import { ByPublisherPageComponent } from './features/numerons/pages/by-publisher-page.component';
import { CollectionPageComponent } from './features/numerons/pages/collection-page.component';
import { CreateCollectionPageComponent } from './features/numerons/pages/create-collection-page.component';
import { DeleteCollectionNumeronPageComponent } from './features/numerons/pages/delete-collection-numeron-page.component';
import { DeleteNumeronPageComponent } from './features/numerons/pages/delete-numeron-page.component';
import { EditNumeronPageComponent } from './features/numerons/pages/edit-numeron-page.component';
import { LatestPageComponent } from './features/numerons/pages/latest-page.component';
import { ManageCollectionPageComponent } from './features/numerons/pages/manage-collection-page.component';
import { ManageNumeronPageComponent } from './features/numerons/pages/manage-numeron-page.component';
import { MyNumeronsByTopicPageComponent } from './features/numerons/pages/my-numerons-by-topic-page.component';
import { MyNumeronsByCategoryPageComponent } from './features/numerons/pages/my-numerons-by-category-page.component';
import { MyNumeronsPageComponent } from './features/numerons/pages/my-numerons-page.component';
import { MostViewedPageComponent } from './features/numerons/pages/most-viewed-page.component';
import { NumeronPageComponent } from './features/numerons/pages/numeron-page.component';
import { SearchPageComponent } from './features/numerons/pages/search-page.component';
import { numeronCollectionResolver } from './features/numerons/resolvers/numeron-collection.resolver';
import { TopicsPageComponent } from './features/topics/pages/topics-page.component';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'numerons/latest',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component: SignInPageComponent,
  },
  {
    path: 'topics',
    component: TopicsPageComponent,
  },
  {
    path: 'numerons/numeron/:collectionId',
    component: NumeronPageComponent,
    resolve: {
      numeronCollection: numeronCollectionResolver,
    },
  },
  {
    path: 'numerons/collection/:collectionId',
    component: CollectionPageComponent,
    resolve: {
      numeronCollection: numeronCollectionResolver,
    },
  },
  {
    path: 'numerons/latest',
    component: LatestPageComponent,
  },
  {
    path: 'numerons/mostviewed',
    component: MostViewedPageComponent,
  },
  {
    path: 'mynumerons',
    component: MyNumeronsPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/bytopic/:topicId',
    component: MyNumeronsByTopicPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/bycategory/:category',
    component: MyNumeronsByCategoryPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/collection/new',
    component: CreateCollectionPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'create',
    },
  },
  {
    path: 'mynumerons/collection/:collectionId/edit',
    component: CreateCollectionPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'edit',
    },
  },
  {
    path: 'mynumerons/numeron/new',
    component: EditNumeronPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'create',
    },
  },
  {
    path: 'mynumerons/collection/:collectionId',
    component: ManageCollectionPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/collection/:collectionId/addnumeron',
    component: EditNumeronPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'add-to-collection',
    },
  },
  {
    path: 'mynumerons/collection/:collectionId/numeron/:numeronId/delete',
    component: DeleteCollectionNumeronPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/numeron/:collectionId/:numeronId/update',
    component: EditNumeronPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'edit-in-collection',
    },
  },
  {
    path: 'mynumerons/numeron/:collectionId',
    component: ManageNumeronPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'mynumerons/numeron/:collectionId/edit',
    component: EditNumeronPageComponent,
    canActivate: [authGuard],
    data: {
      mode: 'edit',
    },
  },
  {
    path: 'mynumerons/:collectionId/delete',
    component: DeleteNumeronPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'numerons/mynumerons',
    redirectTo: 'mynumerons',
    pathMatch: 'full',
  },
  {
    path: 'numerons/search',
    component: SearchPageComponent,
  },
  {
    path: 'numerons/bytopic/:topicId',
    component: ByTopicPageComponent,
  },
  {
    path: 'numerons/bypublisher/:publisherId',
    component: ByPublisherPageComponent,
  },
  {
    path: 'numerons/bycategory/:category',
    component: ByCategoryPageComponent,
  },
  {
    path: '**',
    redirectTo: 'numerons/latest',
  },
];
